import { render } from "./internal_return_approval.vue?vue&type=template&id=8280ca2c&scoped=true"
import script from "./internal_return_approval.vue?vue&type=script&lang=js"
export * from "./internal_return_approval.vue?vue&type=script&lang=js"

import "./internal_return_approval.vue?vue&type=style&index=0&id=8280ca2c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8280ca2c"]])

export default __exports__